import { useNavigate, useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import YearColorForm from "../_components/YearColorForm";
import styles from "../Notice.module.css";
import apiService from "../../../../services/api";
import { setupAutoLogout } from "../../../../utils/auth";

export default function FormClient() {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const year = searchParams.get('year'); // 수정 모드인지 확인
    const [yearColorData, setYearColorData] = useState(null);
    const [loading, setLoading] = useState(false);
    
    // 인증 확인 및 자동 로그아웃 설정
    useEffect(() => {
        if (!apiService.isAuthenticated()) {
            navigate("/admin/login");
            return;
        }

        const cleanup = setupAutoLogout(() => {
            console.log('Year color form auto logout triggered');
            navigate("/admin/login");
        });

        apiService.setTokenExpiredCallback(() => {
            console.log('Year color form API service token expired callback');
            navigate("/admin/login");
        });

        return cleanup;
    }, [navigate]);
    
    // 수정 모드일 때 기존 데이터 가져오기
    useEffect(() => {
        if (year) {
            const fetchYearColorData = async () => {
                setLoading(true);
                try {
                    console.log('Fetching year color data for year:', year);
                    const response = await apiService.getYearColorByYear(year);
                    console.log('Year color response:', response);
                    
                    // 연도별 데이터 추출
                    if (response) {
                        setYearColorData({
                            year: parseInt(year),
                            ...response
                        });
                    } else {
                        alert('해당 연도의 올해의 컬러 정보를 찾을 수 없습니다.');
                        navigate("/admin/notices?tab=year-color");
                    }
                } catch (error) {
                    console.error('올해의 컬러 데이터 가져오기 실패:', error);
                    alert(`올해의 컬러 정보를 가져오는데 실패했습니다: ${error.message || '알 수 없는 오류'}`);
                    navigate("/admin/notices?tab=year-color");
                } finally {
                    setLoading(false);
                }
            };
            
            fetchYearColorData();
        }
    }, [year, navigate]);
    
    const handleSubmit = () => {
        navigate("/admin/notices?tab=year-color");
    };
    
    const handleCancel = () => {
        navigate("/admin/notices?tab=year-color");
    };

    if (loading) {
        return (
            <div className={styles.noticeWrap}>
                <div className={styles.SubPageWidth}>
                    <div className={styles.header}>
                        <h1>{year ? `${year}년 올해의 컬러 수정` : "올해의 컬러 등록"}</h1>
                        <button onClick={handleCancel} className={styles.backBtn}>
                            목록으로
                        </button>
                    </div>
                    <div style={{ textAlign: 'center', padding: '50px' }}>
                        데이터를 불러오는 중...
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className={styles.noticeWrap}>
            <div className={styles.SubPageWidth}>
                <div className={styles.header}>
                    <h1>{year ? `${year}년 올해의 컬러 수정` : "올해의 컬러 등록"}</h1>
                    <button onClick={handleCancel} className={styles.backBtn}>
                        목록으로
                    </button>
                </div>
                
                <YearColorForm 
                    item={yearColorData}
                    onSubmit={handleSubmit}
                    onCancel={handleCancel}
                />
            </div>
        </div>
    );
}

